import React from 'react'
import PropTypes from 'prop-types'
import { Swiper } from 'antd-mobile'

export class PacketList extends React.PureComponent {

  static propTypes = {
    index: PropTypes.number,
    packetList: PropTypes.array
  }

  render () {
    let { packetList, index } = this.props
    return <div className="my-4">
      {
        (packetList.length > 0)
          ? <Swiper
            indicator={false}
            slideSize={33}
            defaultIndex={index}
          >{
            packetList.map(item => {
              let text = ''
              let className = 'RP__swiper__item'
              if (item['finished']) {
                text = '已结束'
                className += ' RP__swiper__item--disable'
              } else if (item['started']) {
                text = '正在进行'
              } else {
                text = '即将开抢'
              }
              return <Swiper.Item key={item['openTime']}>
                <div className={className}>
                  {text}
                  <br/>
                  {item['openTime']}
                </div>
              </Swiper.Item>
            })
          }</Swiper>
          : null
      }
    </div>

  }
}
